<template>
  <div>
    <b-field label="Jobsite Name">
      <b-input type="text" placeholder="jobsite name" v-model="newJobsite.nameJobsite"></b-input>
    </b-field>
    <!--<b-field label="Jobsite Number">
      <b-input type="number" v-model="newJobsite.numberJobsite"></b-input>
    </b-field>-->
    <b-field label="Location">
      <b-input type="text" placeholder="Adreess" v-model="newJobsite.location"></b-input>
    </b-field>
    <b-field label="Country">
      <b-select placeholder="country" expanded v-model="newJobsite.country">
        <option v-for="item in country" :value="item.name" :key="item.id">{{ item.name }}</option>
      </b-select>
    </b-field>
    <div class="columns">
      <div class="column">
        <b-field label="Coordinates">
          <b-input placeholder="Latitude" v-model="newJobsite.coordinateLat"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="-">
          <b-input placeholder="Longitude" v-model="newJobsite.coordinateLng"></b-input>
        </b-field>
      </div>
    </div>
    <b-field label="Job type">
      <b-select placeholder="tunnel / microtunnel / other" expanded v-model="newJobsite.type">
        <option value="tunnel">Tunnel</option>
        <option value="microtunnel">Microtunnel</option>
        <option value="other">Other</option>
      </b-select>
    </b-field>
    <b-field label="Jobsite condition">
      <b-select placeholder="ongoing / closed" expanded v-model="newJobsite.state">
        <option value="ongoing">Ongoing</option>
        <option value="closed">Closed</option>
        <option value="notstarted">Not started</option>
        <option value="archived">Archived</option>
      </b-select>
    </b-field>
    <b-field label="Email expedition days">
      <b-select placeholder="Email expedition days" expanded v-model="newJobsite.expedition">
        <option value="workingDays">Working days</option>
        <!--<option value="workableDays">Workable days</option>-->
        <option value="calendarDays">Calendar days</option>
      </b-select>
    </b-field>
    <!--
    <b-field label="Address">
      <b-input maxlength="200" type="textarea" v-model="newJobsite.adress"></b-input>
    </b-field>-->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Create',
  data() {
    return {
      newJobsite: {
        nameJobsite: '',
        numberJobsite: '',
        location: '',
        country: '',
        coordinateLat: '',
        coordinateLng: '',
        type: 'tunnel',
        state: 'ongoing',
        expedition: 'workingDays',
        adress: ''
      },
    }
  },
  mounted() {
    this.$store.dispatch('getUser')
    this.$emit('newJobsite', this.newJobsite)
  },
  computed: {
    ...mapState(['country']),
  },
}
</script>